import React, { useState } from "react";
import { Redirect } from "react-router-dom";

import { AffiliatePage } from "../../layouts/AffiliatePage";
import { OpportunityLinkView } from "../../molecules/OpportunityLinkView";

import { useOpportunityDetails, useOpportunityLinkAlert } from "./hooks";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { CreateApplicationEvent } from "./mutations";
import useAuthState from "../../hooks/useAuthState";

import { Spinner, Alert } from "@blueprintjs/core";
import styles from "./OpportunityLink.module.scss";
import { NotFound } from "../Error";

function OpportunityLink({ history, match, location }) {
  const { loading, opportunity } = useOpportunityDetails({
    opportunityId: match.params.opportunityId
  });
  const [createApplicationEvent] = useMutation(CreateApplicationEvent);
  const { user, logout } = useAuthState();
  const [opportunityApplied, setOpportunityApplied] = useState(false);
  const [alertText, setAlertText] = useState();
  const { product } = opportunity || {};
  const { owner } = product || {};
  const {
    alertState,
    setAlertState,
    defaultIcon,
    onAlertOpen
  } = useOpportunityLinkAlert({ setAlertText, opportunity });

  if (loading)
    return (
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    );
  else if (!opportunity || !opportunity.isActive) return <NotFound />;
  else
    return (
      <AffiliatePage
        title={opportunity.product.name}
        backgroundImage={owner.preference && owner.preference.backgroundImage}
        backgroundColor={owner.preference && owner.preference.backgroundColor}
        location={location}
        brandName={owner.name || ""}
        showHeaderOptions={false}
      >
        <OpportunityLinkView
          opportunity={opportunity}
          onAlertOpen={onAlertOpen}
          currentUser={user}
          logout={logout}
          opportunityApplied={opportunityApplied}
          location={location}
        />

        <Alert
          className={styles.confirmAlert}
          icon={defaultIcon}
          isOpen={alertState.visible}
          onCancel={() => setAlertState({ visible: false })}
          onConfirm={async () => {
            setAlertState({
              visible: false
            });

            setOpportunityApplied(true);

            await createApplicationEvent({
              variables: {
                applicationEvent: {
                  opportunity: opportunity.id,
                  status: "Applied",
                  applicant: user.sub,
                  message: alertText ? alertText : undefined
                }
              }
            });
          }}
          {...alertState}
        />
      </AffiliatePage>
    );
}

export default OpportunityLink;
